import { BaSeButton, BaSeContainer, BaSeInput } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import { useManageClassService } from '../../../../../../../hooks/services/manage-class-service';
import Message from './message';

const cache = Sebrae.StorageUtil.inTemporaryStore();
function Comments({ comments, idInterview }) {
  const cacheCommentTempKey = `@empretec:comment${idInterview}`;
  const [comment, setComment] = React.useState('');
  const [allComments, setAllComments] = React.useState(comments);

  const { createComment } = useManageClassService();

  React.useEffect(() => {
    if (!cache.hasItem(cacheCommentTempKey)) {
      cache.setItem(cacheCommentTempKey, comments);
    } else {
      setAllComments(cache.getItem(cacheCommentTempKey));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comments]);

  const handleSaveComment = React.useCallback(() => {
    const textComment = comment.trim();
    if (textComment === '') return;
    createComment(textComment, idInterview)
      .then((response) => {
        setComment('');
        setAllComments((prev) => {
          const newpREV = [...prev];
          newpREV.unshift(response);
          cache.setItem(cacheCommentTempKey, newpREV);
          return newpREV;
        });
      })
      .catch((error) => {
        console.log(error);
        setComment('');
      });
  }, [cacheCommentTempKey, comment, createComment, idInterview]);

  return (
    <div>
      <div>
        <div style={{ display: 'flex', gap: 4 }}>
          <BaSeInput
            value={comment}
            counterMaxLength={140}
            maxLength={140}
            onChange={(e) => {
              setComment(e);
            }}
            l
            hasCounter="chars"
            placeholder="Digite aqui seu comentário"
          />
          <div style={{ height: 40 }}>
            <BaSeButton value="+" onClick={handleSaveComment} />
          </div>
        </div>

        <div style={{ marginTop: 8 }}>
          <BaSeContainer style={{ maxHeight: '30vh' }} withAutoScroll>
            {allComments.map((info) => (
              <Message
                key={info.id}
                message={info.textComment}
                dateInclusion={info.dataInclusion}
                user={info.user.name}
              />
            ))}
          </BaSeContainer>
        </div>
      </div>
    </div>
  );
}

export default Comments;
